/** @jsx jsx */
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import { useTranslation } from "react-i18next"
import { Flex } from "rebass"
import Headroom from "react-headroom"

import Link from "../../atoms/Link"
import PageWrap from "../../atoms/PageWrap"

import { getResolvedLocale, getDataForLocale } from "../../../utils/i18n"

import logoSrc from "../../../images/logo.svg"

import MobileMenu from "../MobileMenu"

const Header = ({ location }) => {
  const { i18n } = useTranslation()
  const { sanityNavigation } = useStaticQuery(query)
  const resolvedLocale = getResolvedLocale(i18n)
  const data = getDataForLocale(sanityNavigation, resolvedLocale.config.code)

  return (
    <Headroom
      sx={{
        position: "relative",
        zIndex: theme => theme.indexes.header,

        ".headroom": {
          transition: "background 0.2s",
        },

        ".headroom--scrolled": {
          background: "white",
        },
      }}
    >
      <PageWrap>
        <Flex
          as="header"
          sx={{
            alignItems: "center",
            py: 3,
            variant: "styles.header",
          }}
        >
          <Link
            to=""
            sx={{
              variant: "variants.header.nav",
              [i18n.dir() === "rtl" ? "ml" : "mr"]: "auto",
            }}
          >
            <img
              src={logoSrc}
              width={113}
              height={56}
              sx={{
                display: "block",
              }}
            />
          </Link>
          <div sx={{ display: ["none", "block"] }}>
            {data.header.map((navItem, index) => (
              <Link
                key={navItem.url}
                to={navItem.url}
                activeClassName="active"
                sx={{
                  variant: "variants.header.nav",
                  ...(index && { ml: 5 }),
                  "&.active, &:hover": {
                    color: "primary",
                    textDecoration: "underline",
                  },
                }}
              >
                {navItem.label}
              </Link>
            ))}
          </div>
          <MobileMenu location={location} />
        </Flex>
      </PageWrap>
    </Headroom>
  )
}

export default Header

const query = graphql`
  query Nav {
    sanityNavigation {
      header {
        url
        label {
          ...StringAllLanguages
        }
      }
    }
  }
`
